module.exports = __webpack_public_path__ + "img/footer-text_767.24ea82ed.png";